import React, { useCallback } from 'react';
import css from './styles.module.scss';
import { StepControls } from '~/common/step-controls';
import { useForm } from 'react-hook-form';
import { INewDealStepThreeFormInputs } from '~/models/deals/new-deal/formInputs';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Button, Chip, Grid, Typography } from '@material-ui/core';
import { newDealFormNextStep } from '~/features/dashboard/store/actions';
import classNames from 'classnames';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';

interface Step_5Props {
    prevStep: () => void;
}

export const Step_5: React.FC<Step_5Props> = ({ prevStep }) => {
    const dispatch = useThunkDispatch();

    const {
        handleSubmit,
        register,
    } = useForm<INewDealStepThreeFormInputs>({
        defaultValues: {},
    });

    const onSubmit = useCallback(
        (data: INewDealStepThreeFormInputs) => {
            dispatch(newDealFormNextStep());
        },
        [dispatch]
    );
    return (
        <div className={css.module}>
            <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                <Typography align={'left'} variant={'h6'} className={classNames(css.bold, css.title)}>
                    test - test the Statement Received
                </Typography>
                <Grid container spacing={3} className={css.container}>
                    <Grid item xs={12} className={css.box}>
                        <label className="customlabel bold">Statement Summary</label>
                    </Grid>

                    {/*Deductions Amount*/}
                    <Grid item xs={2} className={css.box}>
                        <label className="customlabel bold">Deductions Amount</label>
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Chip className={css.chip} label={'$123.23'} onDelete={() => console.log('delete')} />
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>Details</Button>
                    </Grid>

                    {/*Other Deductions*/}
                    <Grid item xs={2} className={css.box}>
                        <label className="customlabel bold">Other Deductions</label>
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Chip className={css.chip} label={'$123.23'} onDelete={() => console.log('delete')} />
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>Details</Button>
                    </Grid>

                    {/*Total Deductions*/}
                    <Grid item xs={5} className={css.box}>
                        <label className="customlabel bold">Total Deductions</label>
                    </Grid>
                    <Grid item xs={4} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                </Grid>
                <StepControls onPrevClick={prevStep} className={css.nextButton} />
            </form>
        </div>
    );
};
